import { modalWindows as EnUsModalWindows } from '../en-us/modalWindows';
import { AgResourceLanguage } from '../types';

export const modalWindows: AgResourceLanguage['modalWindows'] = {
  ...EnUsModalWindows,
  editShippingMethod: {
    titleHeader: 'Versandarten',
    subtitle: 'Auswählen:',
    saveMethodButton: 'Speichern'
  },
  shopAlert: {
    deleteButtonTitle: 'Continue',
    cancelButtonTitle: 'Cancel',
    makeGiftCartButtonTitle: 'As a Gift',
    subToGift: {
      headerTitle: 'Before you add a subscription',
      content:
        'Gift orders can only include products that ship one time. Adding a subscription to your cart will remove gift products.'
    },
    giftToSub: {
      headerTitle: 'Before you add a gift',
      content:
        'Subscription orders cannot be sent with a gift message. Adding a gift to your cart will remove subscription products.'
    },
    giftToOtp: {
      headerTitle: 'Make the whole order as a gift',
      content:
        'You already have one time purchase products in Cart. Do you want to make the whole order as a gift?'
    }
  },
  addProductFromSlider: {
    toastNextOrder: 'Produkt hinzugefügt zur nächsten Lieferung am ',
    toastSubscription: 'Produkt zu {{name}} hinzugefügt',
    toastSeveralSubscription: 'Produkt zu',
    severalSubscriptions: 'abonnements',
    toastToAllSubscription: 'Produkt zu allen Abonnements hinzugefügt',
    toastToAllNextOrder: 'Produkt zur nächsten Lieferung aller Abos hinzugefügt',
    titleSubscription: 'Bestellungen',
    titleNextOrder: 'Produkt zur nächsten Bestellung hinzufügen',
    checkbox: 'Zu allen aktiven Abonnements hinzufügen',
    text: 'Wähle das Abonnement aus, für das du ein Produkt zur nächsten Bestellung hinzufügen möchtest.',
    addProductButton: 'Produkt hinzufügen'
  },
  switchProduct: {
    modalTitle: 'Zu {{productName}} wechseln',
    quantityText: 'Anzahl der zu ändernden {{switchToText}}',
    title:
      'Deine nächste Lieferung am {{formatNextOrderDate}} enthält {{qtyModal}} {{switchToText}}.',
    cancelButton: 'Zurück',
    pouchName: 'Monatspackung',
    confirmButton: 'Bestätigen',
    description:
      'Du können die Anzahl Ihrer {{switchToText}} auf der Seite "Abonnement verwalten" ändern.',
    packName: 'Travel Packs',
    infoMessage: 'Das Produkt wird nur für deine nächste Lieferung geändert.'
  },
  acceptChanges: {
    cancelButton: 'Zurück',
    text: 'Durch die Aktualisierung deiner Abo-Details werden deine nächsten Bestellung ausgesetzt und einmalig hinzugefügte Artikel entfernt.',
    title: 'Bevor du dein Abo anpasst',
    continueButton: 'Ja, fortfahren'
  },
  skipShipment: {
    continueButton: 'Ja, fortfahren',
    headConfirm: 'Diese Lieferung überspringen',
    textConfirm: 'Das nächste Bestelldatum wird auf den {{date}} geändert.',
    skipButton: 'Zurück',
    questionConfirm: 'Bist du sicher, dass du die nächste Lieferung überspringen willst? '
  },
  editFrequency: {
    titleView: 'Versandfrequenz ändern',
    titleDatepicker: 'Nächstes Bestelldatum ändern',
    day: 'Tage',
    infoMessage: 'Versandhäufigkeit wurde auf {{date}} geändert.',
    shippingFrequency: 'Lieferfrequenz',
    item: 'Alle',
    nextOrderButton: 'Nächstes Bestelldatum',
    nextOrderLink: 'Nächstes Bestelldatum ändern',
    nextOrder: 'Nächste Bestellung:',
    followedBy: 'Gefolgt von:',
    description: 'Die Änderungen treten ab dem nächsten Bestelldatum in Kraft.',
    followingText: 'nächsten',
    ribbonMessage:
      'Diese Änderung gilt nur für Bestellungen nach deinem <bold>{{followingText}}</bold> Lieferdatum.',
    extraInfo:
      'Sobald du unten bestätigst, wird die Bezahlung betätigt und deine Bestellung innerhalb eines Werktages versendet. An Wochenenden und Feiertagen kann das bis zu 48 Stunden dauern.',
    saveButton: 'Änderungen speichern',
    confirmButton: 'Bestätigen'
  },
  addProductFromModal: {
    noteTitle: 'How to swap from AG1 Pouch to AG1 30 Ct Travel Packs',
    noteSubtitle:
      'To swap between Pouch and 30 Ct Travel Packs, add the desired product to your subscription by selecting “Add to Subscription”. Once added, remove the other product from your subscription by selecting the trash can icon on your Subscription Details page.',
    addToSubscription: 'Zahlungspflichtig abonnieren',
    addToNextOrder: 'Einmalig zahlungspflichtig bestellen',
    addedToNextOrder: 'Zur nächsten Bestellung hinzugefügt',
    addedToSubscription: 'Zum Abonnement hinzugefügt',
    addToOrder: 'Zur Bestellung hinzufügen',
    preferredFlavorText: 'Member preferred flavor'
  },
  cart: {
    title: 'Your Cart',
    checkoutButtonLabel: 'Checkout',
    summary: {
      taxNotReady: '---',
      freePrice: 'Kostenlos',
      shippingLabel: 'Versand',
      taxLabel: 'MwSt.',
      discountLabel: 'Dein Rabatt',
      totalLabel: 'Gesamt',
      subtotalLabel: 'Zwischensumme',
      taxEstimatedLabel: 'Estimated Tax'
    },
    emptyState: {
      oneTimeProductsTitle: 'Members Favorites',
      addOneTimeProductButton: 'Add to Cart',
      label: 'Add items to your cart'
    },
    emptyStateLabel: 'Add items to your cart',
    frequencyLabel: 'Ships every 30 days',
    promoCode: {
      promoCTA: 'Hast Du einen Promo-Code?',
      promoError: 'Code ist nicht gültig.',
      promoInputLabel: 'Promo-Code',
      promoButtonLabel: 'Anwenden'
    },
    subscriptionTitle: 'Subscription'
  },
  cancelSubscription: {
    text: 'Gemäß unserer hohen Ansprüche an AG1 und die gesamte User-Experience, möchten wir uns  ständig weiterentwickeln. Wir freuen uns daher zu erfahren, was die Gründe für die Kündigung des Abos sind.',
    title: 'Wir bedauern, dass Du gehst!',
    keepButton: 'Behalte es',
    commentsPlaceholder: 'Beschreibe das Problem',
    cancelButton: 'Abonnement kündigen',
    reasons:
      'Ich spüre die erwartete Wirkung nicht, Ich ziehe um oder verreise, Ich habe mehr AG1 als ich benötige, Ich habe gesundheitliche Gründe, Es ist zu teuer, Ich mag den Geschmack nicht, Ich möchte kein Abonnement, Anderer Grund',
    v53Reasons: 'Ich mag die neue Formel nicht,Ich mag den neuen tropischen Geschmack nicht',
    agzCancelationReasons:
      'Ich mag den Geschmack von AGZ nicht,Ich habe keine Vorteile von AGZ bemerkt,Ich habe bereits mehr AGZ als ich brauche,Ich möchte kein Abonnement,Ich habe einen medizinischen Grund,Das ist zu teuer,Ich ziehe um, um zu reisen,Anderer Grund',
    commentsLabel: 'Kommentare',
    keepSubscriptionButton: 'Abonnement behalten'
  },
  changeOrderDate: {
    description: 'Das nächste Bestelldatum kann um bis zu 60 Tage nach hinten verschoben werden.',
    newDateChangeText: 'Die nächste Bestellung erfolgt am',
    newDateSuccessText: 'Das nächste Bestelldatum wurde zu {{date}} geändert.',
    title: 'Versanddatum ändern',
    confirmButton: 'Bestätigen',
    nextOrderDateSuccessText:
      'Das zukünftige Bestelldatum für dieses Abonnement wird auf den {{date}} verschoben.',
    nextOrderDateChangeText:
      'Das zukünftige Bestelldatum für dieses Abonnement wird auf den {{date}} verschoben.'
  },
  activateSubscription: {
    activateButton: 'Abonnement zahlungspflichtig aktivieren',
    title: 'Abonnement Erneuern',
    infoMessage:
      'Du kannst das Datum deiner nächsten Bestellung ändern, bevor dein Abo aktiviert wird.',
    successDescription: 'Die nächste Bestellung erfolgt am {{date}}',
    successTitle: 'Dein Abonnement {{name}} ist aktiv und kann verwaltet werden.',
    errorMessage: 'Änderung des Versanddatums nicht möglich'
  },
  acceptAddressValidation: {
    continueButton: 'Speichern fortsetzen',
    enteredTitle: 'Eingegebene Adresse:',
    editButton: 'Adresse bearbeiten',
    suggestedTitle: 'Vorgeschlagene Adresse:',
    text: 'Wir konnten die von dir eingegebene Adresse nicht genau überprüfen. Bitte vergewissere dich, dass sie korrekt ist oder nimm die notwendigen Änderungen vor.',
    title: 'Bestätige deine Adresse'
  },
  editShippingAddress: {
    bannerText: 'Die Lieferadresse wird zum nächsten Versand geändert',
    address2: 'Wohnung, Zimmer usw. ',
    address1: 'Adresse',
    subscriptionUpdate: 'Als Lieferadresse für mein Abonnement festlegen',
    selectAddress: {
      reloadMessage: 'Bitte Seite neu laden',
      noSavedAddressText: 'Aktuell sind keine gespeicherten Adressen vorhanden.',
      useSavedAddressButton: 'Gespeicherte Adresse verwenden',
      noSavedAddressButton: 'Keine gespeicherten Adressen',
      titleForSelectAddressModal: 'Versandadresse auswählen',
      cancelButton: 'Zurück',
      submitButton: 'Ok',
      useSelectButton: 'Ausgewählte verwenden'
    },
    cancelButton: 'Zurück',
    deleteAddressTitle: 'Adresse löschen',
    city: 'Stadt',
    massUpdate: 'Bei allen aktiven Abos verwenden',
    phone: 'Telefon',
    titleAddress: 'Adresse bearbeiten',
    titleHeaderCreate: 'Lieferadresse hinzufügen',
    usedSavedLabel: 'Gespeicherte Adresse verwenden',
    country: 'Land/Region',
    deleteAddressText: 'Möchten Sie diese Gespeicherte Adresse wirklich entfernen?',
    zip: 'PLZ',
    last_name: 'Nachname',
    titleHeaderEdit: 'Versandadresse bearbeiten',
    company: 'Firma',
    province: 'Bundesstaat',
    first_name: 'Vorname',
    updateButton: 'Aktualisieren'
  },
  shipNow: {
    shipNowButton: 'Zahlungspflichtig Bestellen',
    subtitle: 'Deine Bestellung war erfolgreich',
    description:
      'Normalerweise versenden wir montags bis freitags innerhalb von 24 Stunden nach erfolgreicher Zahlung. An Wochenenden und Feiertagen kann es bis zu 48 Stunden dauern. Die Folgebestellung wird in {{shipInterval}}, am {{date}}, aufgegeben',
    title: 'Jetzt versenden',
    confirm:
      'Wenn Sie unten bestätigen, wird Ihre Bestellung innerhalb eines Werktages bearbeitet. An Wochenenden und Feiertagen kann es bis zu 48 Stunden dauern.',
    preparing: 'In Vorbereitung',
    preparingDescription: 'Deine aktuelle Bestellung wird versendet am',
    shipped: 'Versendet',
    shippedDescription: 'Deine aktuelle Bestellung wurde versendet am',
    delivered: 'Geliefert',
    deliveredDescription: 'Deine letzte Bestellung wurde geliefert am',
    shipNext: 'Nächste Bestellung:',
    nextOrder: 'Nächste Bestellung:',
    followedBy: 'Gefolgt von:'
  },
  addPaymentMethod: {
    title: 'Zahlungsmethode hinzufügen',
    instructions:
      'Es wird eine E-Mail an {{email}} gesendet, um Ihre hinterlegte Zahlungsmethode sicher hinzuzufügen. Bestätigen Sie unten, um eine E-Mail zu senden.'
  },
  editPaymentMethod: {
    title: 'Zahlungsmethode bearbeiten',
    instructions:
      'Eine E-Mail wird an {{email}} gesendet, um Ihre hinterlegte Zahlungsmethode sicher zu bearbeiten. Bestätigen Sie unten, um eine E-Mail zu senden.',
    shopPayInstructions: `Eine E-Mail wird an {{email}} gesendet, um Ihre Zahlungsmethode in Shop Pay sicher zu bearbeiten. Bestätigen Sie unten, um die E-Mail zu senden. \n
      Wenn Sie die Zahlungsmethode von Shop Pay auf eine andere Zahlungsmethode, wie PayPal oder Apple Pay, ändern möchten, kündigen Sie bitte Ihr Abonnement, indem Sie zu Ihren Abonnementdetails zurückkehren. Nach der Kündigung erstellen Sie ein neues Abonnement und geben die bevorzugte Zahlungsmethode ein.`
  },
  paymentMethod: {
    cancelButton: 'Stornieren',
    submitButton: 'E-Mail senden',
    successTitle: 'Bestätigungs-E-Mail verschickt',
    successMessage: 'Überprüfen Sie in Kürze Ihre E-Mails auf eine E-Mail-Bestätigung'
  },
  addToSubscriptionFromPdp: {
    modalHeader: 'Dein Abonnement',
    ships: 'Ships',
    shipsEvery: 'Versand alle {{count}} Tage',
    manageSubscription: 'Abonnement verwalten',
    continueShopping: 'Weiter einkaufen',
    saving: 'Speichern...',
    productSubtotal: 'Produkt-Zwischensumme',
    taxesEstimated: 'Steuern nach dem Speichern geschätzt',
    createNewSubscription: 'Create New Subscription'
  }
};
